module.exports = __webpack_public_path__ + "img/scarf.5953bf70.svg";